import fetchReportedInventoryVsCalculatedInventorySagas from './fetchReportedInventoryVsCalculatedInventory'

// CODE_COMMENTS_11
export default [
  ...fetchReportedInventoryVsCalculatedInventorySagas,
]
